module.exports = __webpack_public_path__ + "static/img/logo3.69b6a3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/index/logo3.png
// module id = LOtK
// module chunks = 74